/* Coastal Slate & Brass — keep the variant picker on a valid combination.

   Set and Cart Designator are dependent: the front set takes CPR/DRV/TXT, the
   back set takes F-4/GT. Switching Set leaves the previously chosen designator
   selected even though it no longer applies, so the shopper lands on a
   combination that does not exist and the button reads "Unavailable".

   Dawn marks the impossible inputs with class="disabled" (the CSS then hides
   them). This watches for the selected input becoming one of those and moves
   the selection to the first value that is still valid, so the form is never
   left in a dead state and Add to cart stays live.

   Written against the class rather than a hardcoded option name, so it keeps
   working if the options are renamed or a third one is added. */
(function () {
  var busy = false;

  function groups() {
    var out = {};
    document.querySelectorAll('.product-form__input input[type="radio"]').forEach(function (i) {
      (out[i.name] = out[i.name] || []).push(i);
    });
    return out;
  }

  function fix() {
    if (busy) return;
    var changed = false;

    var g = groups();
    Object.keys(g).forEach(function (name) {
      var list = g[name];
      var checked = list.filter(function (i) { return i.checked; })[0];
      if (!checked || !checked.classList.contains('disabled')) return;

      var first = list.filter(function (i) { return !i.classList.contains('disabled'); })[0];
      if (!first) return;                       // whole group unavailable: leave Dawn's message
      busy = true;
      var label = document.querySelector('label[for="' + first.id + '"]');
      (label || first).click();
      busy = false;
      changed = true;
    });

    // Selects behave the same way when the shop uses the dropdown layout.
    document.querySelectorAll('.product-form__input select').forEach(function (sel) {
      var opt = sel.options[sel.selectedIndex];
      if (!opt || !opt.disabled) return;
      for (var i = 0; i < sel.options.length; i++) {
        if (!sel.options[i].disabled && sel.options[i].value) {
          busy = true;
          sel.value = sel.options[i].value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          busy = false;
          changed = true;
          break;
        }
      }
    });

    return changed;
  }

  // Dawn re-renders the picker after each change, so react to the markup
  // settling rather than to the click itself.
  var pending;
  function schedule() {
    clearTimeout(pending);
    pending = setTimeout(fix, 80);
  }

  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('.product-form__input')) schedule();
  });
  document.addEventListener('shopify:section:load', schedule);

  var host = document.querySelector('variant-selects, variant-radios, .product-form__input');
  if (host && window.MutationObserver) {
    new MutationObserver(schedule).observe(host.parentNode || host, { childList: true, subtree: true });
  }

  schedule();
})();
